import { atom } from 'jotai';

export const magicEditBrushSizeAtom = atom(30);
